import React from "react";
import styles from "../styles/instrumentsTable.module.css";
import SearchInstruments from "./searchInstruments";
import CloseIcon from '@mui/icons-material/Close'
import TimerIcon from '@mui/icons-material/Timer'
import {Button} from "antd";

export default function InstrumentsHeader(props) {
  const { searchInstruments } = props;
  return (
    <>
      <div>
        <div className={styles.headerRow2}>
          <div className={styles.headerRow2Col1}>
            <div className={styles.headerRow2Col1Container}>
              <SearchInstruments
                className={styles.headerRow2Col1Item1}
                showSearch
                allowClear
                searchInstruments={searchInstruments}
              />
              <Button
                  size="large"
                  onClick={props.toggleDelayFilter}
                  style={{
                    height: "100%",
                    backgroundColor: 'rgba(0,0,0,0)',
                    padding: '4px 12px',
                  }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <TimerIcon
                      style={{
                        fontSize: 20,
                        color: '#FA8C16',
                      }}
                  />
                  <div style={{ fontSize: 14 }}>Delayed</div>
                  {props.isDelayedFilterActive && (
                      <CloseIcon
                          onClick={(e) => props.toggleDelayFilter(e)}
                          style={{
                            fontSize: 16,
                            color: '#111',
                          }}
                      />
                  )}
                </div>
              </Button>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
